var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};

// libs/ui-components/src/lib/modules/segmented-control/segmented-control.element.ts
import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

// libs/ui-components/src/lib/modules/segmented-control/segmented-control.style.ts
import { mobileMediaCSS } from "@one-inch-community/core/lit";
import { css } from "lit";
var segmentedControlContainerStyle = css`
    :host {
        display: block;
    }
    
    .container {
        position: relative;
        background-color: var(--color-background-bg-secondary);
        padding: 2px;
        display: flex;
        align-items: center;
        cursor: pointer;
        user-select: none;
        outline: none;
        box-sizing: border-box;
        width: 100%;
    }
    
    .container-m {
        border-radius: 10px;
        height: 36px;
    }
    
    .container-l {
        border-radius: 12px;
        height: 48px;
    }
    
    .caret {
        position: absolute;
        background-color: var(--color-background-bg-active);
        height: 32px;
        border-radius: 8px;
        box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.12), 0 1px 4px 0 rgba(0, 0, 0, 0.12);
        color: var(--primary);
        width: 30px;
        z-index: 0;
    }

    .caret-transition {
        transition: transform .2s;
    }
    
`;
var segmentedControlItemStyle = css`

    .item {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-items: center;
        padding: 6px 16px;
        z-index: 1;
        width: 100%;
        font-size: 16px;
        justify-content: center;
        text-wrap: nowrap;
        transition: color .2s, background-color .2s;
        color: var(--color-content-content-primary);
    }
    
    .select {
        color: var(--primary);
    }
    
    .item-input {
        user-select: none;
        outline: none;
        border: none;
        background-color: transparent;
    }

    ${mobileMediaCSS(css`
        .item {
            font-size: 13px;
            padding: 6px 12px;
        }
    `)}

`;

// libs/ui-components/src/lib/modules/segmented-control/segmented-control.element.ts
import { classMap } from "lit/directives/class-map.js";
import { map } from "lit/directives/map.js";
import { buildEvent, isRTLCurrentLocale, localeChange$, resizeObserver, subscribe } from "@one-inch-community/core/lit";
import { of, tap } from "rxjs";
import { asyncTimeout } from "@one-inch-community/core/async";
var SegmentedControlElement = class extends LitElement {
  constructor() {
    super(...arguments);
    this.size = "m";
    this.items = [];
    this.itemRefList = [];
    this.caretRef = null;
  }
  render() {
    const classes = {
      [`container-${this.size}`]: true
    };
    return html`
      <div class="container ${classMap(classes)}">
        ${map(this.items || [], (item) => this.getItemView(item))}
        <div class="caret"></div>
      </div>
    `;
  }
  async firstUpdated() {
    this.itemRefList = Array.from(this.renderRoot.querySelectorAll("div.item"));
    this.caretRef = this.renderRoot.querySelector(".caret");
    await this.updateComplete;
    this.requestUpdate();
    await asyncTimeout(60);
    this.caretRef?.classList.add("caret-transition");
    this.requestUpdate();
    await asyncTimeout(60);
    subscribe(this, [
      localeChange$.pipe(
        tap(() => this.updated())
      ),
      this.parentElement ? resizeObserver(this.parentElement).pipe(
        tap(() => this.updated())
      ) : of()
    ]);
  }
  updated() {
    if (!this.caretRef) return;
    let offset = 0;
    let width = 0;
    for (const el of this.itemRefList) {
      if (el.classList.contains("select")) {
        width = el.offsetWidth;
        break;
      }
      offset += el.offsetWidth;
    }
    this.caretRef.style.width = `${width}px`;
    this.caretRef.style.transform = `translateX(${offset * (isRTLCurrentLocale() ? -1 : 1)}px)`;
  }
  getItemView(item) {
    const classes = {
      [`item-${this.size}`]: true,
      select: item.value === this.select?.value
    };
    let templateRef = html`${item.label}`;
    if (item.template) {
      templateRef = item.template(
        item,
        item.value === this.select?.value,
        this.caretRef
      );
    }
    return html`
      <div @click="${(event) => this.onSelect(item, event)}" class="item ${classMap(classes)}">
        ${templateRef}
      </div>
    `;
  }
  onSelect(item, event) {
    this.select = item;
    this.requestUpdate();
    this.dispatchEvent(buildEvent("change", item.value, event));
  }
};
SegmentedControlElement.tagName = "inch-segmented-control";
SegmentedControlElement.styles = [
  segmentedControlContainerStyle,
  segmentedControlItemStyle
];
__decorateClass([
  property({ type: String })
], SegmentedControlElement.prototype, "size", 2);
__decorateClass([
  property({ type: Array, attribute: false })
], SegmentedControlElement.prototype, "items", 2);
__decorateClass([
  property({ type: Object, attribute: false })
], SegmentedControlElement.prototype, "select", 2);
SegmentedControlElement = __decorateClass([
  customElement(SegmentedControlElement.tagName)
], SegmentedControlElement);
export {
  SegmentedControlElement
};
//# sourceMappingURL=index.esm.js.map
